<template>
    <div class="apprentice-simple-card">
        <div class="row">
            <div class="col-6 col-md-4">
                <input
                    class="form-control"
                    v-model="search"
                    type="text"
                    :placeholder="$t('quest.search')" />
            </div>
            <div class="col-6 col-md-4">
                <b-form-select
                    class="apprentice-primary-select"
                    v-model="groupSelected"
                    :options="groupOptions"></b-form-select>
            </div>
            <div class="col-12 col-md-4">
                <b-dropdown
                    class="timer-dropdown apprentice-custom-select"
                    id="dropdown-form"
                    :text="$t('quest.select_timers')"
                    ref="dropdown"
                    style="width: 100%">
                    <b-dropdown-form>
                        <div
                            class="form-check"
                            v-for="(deadline, index) in deadlines">
                            <label class="form-check-label">
                                <input
                                    class="form-check-input"
                                    v-model="selectedDeadline"
                                    type="checkbox"
                                    checked="checked"
                                    :value="deadline.id" />Timer {{ deadline.count }} ({{ deadline.shortdate }})
                                <i class="input-helper"></i>
                            </label>
                        </div>
                    </b-dropdown-form>
                </b-dropdown>
            </div>
        </div>

        <hr style="margin-top: 2rem; margin-bottom: 2rem" />

        <div class="table-responsive">
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th>{{ $t('common.name') }}</th>
                        <th>{{ $t('quest.total') }}</th>
                        <th v-for="(deadline, index) in filteredDeadlines">Timer {{ index + 1 }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="user in filteredUsers">
                        <td>{{ user.full_name }}</td>
                        <td>{{ user.total_score }}</td>
                        <td v-for="(deadline, index) in filteredDeadlines">
                            <design-2021-quest-result-progress-bar-component
                                v-if="usermission.deadline_id == deadline.id"
                                v-for="usermission in user.quest_missions"
                                :usermission="usermission"
                                key="usermissions.id"></design-2021-quest-result-progress-bar-component>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="row">
            <div class="col col-md-9"></div>
            <div class="col col-md-3">
                <div class="row">
                    <div class="col-md-12 text-right">
                        <b-progress
                            :max="1"
                            show-value
                            height="1rem"
                            style="float: right; width: 50px; margin-left: 5px">
                            <b-progress-bar
                                :value="1"
                                variant="primary"
                                :title="$t('quest.grade_teacher')"></b-progress-bar>
                        </b-progress>
                        {{ $t('quest.grade_teacher') }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 text-right">
                        <b-progress
                            :max="1"
                            show-value
                            height="1rem"
                            style="float: right; width: 50px; margin-left: 5px">
                            <b-progress-bar
                                :value="1"
                                variant="warning"
                                :title="$t('quest.difficulty')"></b-progress-bar>
                        </b-progress>
                        {{ $t('quest.difficulty') }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 text-right">
                        <b-progress
                            :max="1"
                            show-value
                            height="1rem"
                            style="float: right; width: 50px; margin-left: 5px">
                            <b-progress-bar
                                :value="1"
                                variant="success"
                                title="Upgrade"></b-progress-bar>
                        </b-progress>
                        Bonus
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 text-right">
                        <b-progress
                            :max="1"
                            show-value
                            height="1rem"
                            style="float: right; width: 50px; margin-left: 5px">
                            <b-progress-bar
                                :value="1"
                                variant="danger"
                                title="Deadline score"></b-progress-bar>
                        </b-progress>
                        Deadline percentage
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-quest-rapport-table-component',
    props: ['deadlines', 'users', 'groups'],
    data() {
        var selectedDeadlines = [];
        this.deadlines.forEach((obj) => {
            selectedDeadlines.push(obj.id);
        });

        var groupOptions = [];
        this.groups.forEach((obj) => {
            groupOptions.push({ value: obj.id, text: obj.name });
        });

        return {
            groupSelected: this.groups[0].id,
            search: '',
            cards: this.cardsIn,
            selectedDeadline: selectedDeadlines,
            groupOptions: groupOptions,
        };
    },
    computed: {
        filteredUsers() {
            return this.users.filter((user) => {
                var searched = user.full_name.toLowerCase().includes(this.search.toLowerCase());

                if (!searched) return false;

                if (this.groupSelected != null) {
                    var mainGroup = false;
                    var groupSelected = this.groupSelected;
                    this.groups.forEach((obj) => {
                        if (obj.parent_id == null && groupSelected == obj.id) mainGroup = true;
                    });

                    if (mainGroup) return true;

                    if (user.group_id != this.groupSelected) return false;
                }

                return true;
            });
        },
        filteredDeadlines() {
            var vm = this;
            var deadline = vm.selectedDeadline;

            return vm.deadlines.filter((item) => {
                var matchFilter = false;
                deadline.forEach((key) => {
                    if (item.id === key) {
                        matchFilter = true;
                    }
                });
                return matchFilter;
            });
        },
    },
};
</script>

<style scoped lang="scss">
/*.timer-dropdown button.dropdown-toggle {*/
/*    background: #fff !important;*/
/*    color: #495057 !important;*/
/*    border: 1px solid #ced4da;*/
/*    height: calc(1.5em + 0.75rem + 2px);*/
/*    padding: 0.375rem 1.75rem 0.375rem 0.75rem;*/
/*    font-size: 1rem !important;*/
/*}*/
</style>
